import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';

import AccordionToggle from '../../components/AccordionToggle';

const styles = css`
  @media(min-width: 992px) {
    padding: 50px 20px;
  }
`;

function PlanTour({ plan }) {
  return (
    <div className={styles}>
      <AccordionToggle
        openOnId="tour"
        button={({ contentVisible }) => (
          <div className="">
            <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Plan Tour</h3>
          </div>
        )}
      >
        <div className="container">
          <div className="col-8 embed-responsive embed-responsive-16by9 mx-auto">
            <iframe title="Home Designer" src={get(plan, 'tourUrl')} frameBorder="0" allowFullScreen />
          </div>
        </div>
      </AccordionToggle>
    </div>
  );
}

PlanTour.propTypes = {
  plan: PropTypes.object.isRequired,
};

export default PlanTour;



// WEBPACK FOOTER //
// ./src/pages/PlanDetail/PlanTour.js